import React, { Component } from "react";
import {
  Icon,
  Row,
  Col,
  Card,
  Modal,
  Button,
  Input,
  message,
  Spin,
} from "antd";
import axios from "axios";
import moment from "moment";
import { Translate } from "react-translated";
import F from "../../../Functions";

const { TextArea } = Input;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class DashModal extends Component {
  encrypt = (text) => {
    return btoa(text);
  };

  state = {
    email: "",
    showPassword: false,
    loading: false,
  };
  copyToClipboard = (e) => {
    window.document.getElementById("linkTextarea").select();
    window.document.execCommand("copy");
    window.document.getElementById("linkTextarea").focus();
    message.success("Copied!");
  };
  sendEmail() {
    // validate
    if (this.state.email.trim().length === 0) {
      message.error("Email address is required.");
      return;
    }

    // validate
    if (!F.validateEmail(this.state.email.trim())) {
      message.error("Email address is invalid.");
      return;
    }

    this.setState({ loading: true });
    axios
      .post("/api/send_bfile_invitation", {
        email: this.state.email,
        bfile_id: this.props.bfile.id,
      })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success) {
          message.success("Email sent successfully.");
        } else {
          message.error("Can't send email.");
        }
      });
  }
  render() {
    const { loading } = this.state;
    const { bfile } = this.props;
    const agencyIdEncrypted = this.encrypt(bfile.agency_id);
    const userIdEncrypted = this.encrypt(bfile.user_id);
    const wizardIdEncrypted = this.encrypt(bfile.id);
    console.log("agencyIdEncrypted " + bfile.agency_id)
    console.log("userIdEncrypted " + bfile.user_id);
    console.log("wizardIdEncrypted " + bfile.id)

    return (
      <Modal
        title={<Translate text={`Copy Intelligence Link`} />}
        visible={this.props.showModal}
        // onOk={this.copyToClipboard.bind(this)}
        onCancel={this.props.hideModal}
        // okText={<Translate text={`Copy URL`} />}

        footer={
          <React.Fragment>
            <Button onClick={this.props.hideModal}
              className="borderRadius-28">
              <Translate text={`Cancel`} />
            </Button>
            <Button 
            className="btn-bg-164897 borderRadius-28" 
            onClick={this.copyToClipboard.bind(this)}>
              <Translate text={`Copy URL`} />
            </Button>
          </React.Fragment>
        }

      >
        <Spin indicator={antIcon} spinning={loading}>
          <div className="formBox">
            <TextArea
              id="linkTextarea"
              ref={(textarea) => (this.textArea = textarea)}
              prefix={<Icon type="link" style={{ color: "rgba(0,0,0,.25)" }} />}
              // value={"https://bfilesystem.com/app/bfile/" + bfile.agency_id + "/" + bfile.user_id + "/" + bfile.id}
              value={`${window.location.origin}/app/create-bfile/${agencyIdEncrypted}/${userIdEncrypted}/${wizardIdEncrypted}`}
            // value={"https://bfilesystem.com/app/bfile/" + bfile.token}
            />
            {/* Password comment as not required now as per requirement  */}
            {/* <div style={{ marginTop: 20 }}>
              Password:{" "}
              {this.state.showPassword ? (
                <span className="passwordField">{bfile.invite_password}</span>
              ) : (
                <Button onClick={() => this.setState({ showPassword: true })}>
                  Show Password
                </Button>
              )}
            </div> */}
            {/* send email comment as not required now as per requirement  */}
            {/* <div style={{ marginTop: 20 }}>
              <label>Send invite link by email:</label>
              <Input
                className="sendEmail"
                addonAfter={
                  <Button onClick={() => this.sendEmail()}>Send</Button>
                }
                placeholder="Email"
                onChange={(e) => this.setState({ email: e.target.value })}
              />
            </div> */}
          </div>
        </Spin>
      </Modal>
    );
  }
}

export default DashModal;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/parts/invitation-link-modal.js